import React from "react";
import { AlertTriangle } from "lucide-react";
import { contrastRatio, suggestReadable } from "../lib/colors";

const MIN_RATIO = 4.5;

export const ReadabilityWarning = ({ color, against = [], onFix, testid }) => {
  const worst = against
    .map((a) => ({ ...a, ratio: contrastRatio(color, a.bg) }))
    .filter((a) => a.ratio !== null)
    .sort((x, y) => x.ratio - y.ratio)[0];
  if (!worst || worst.ratio >= MIN_RATIO) return null;
  const fix = suggestReadable(color, worst.bg, MIN_RATIO);
  return (
    <div data-testid={`${testid}-warning`} className="mt-2 flex items-start gap-2 rounded-lg bg-amber-50 border border-amber-200 px-3 py-2 text-xs text-amber-800">
      <AlertTriangle size={14} className="mt-0.5 shrink-0" />
      <span className="flex-1">Hard to read on {worst.label} — contrast <strong data-testid={`${testid}-ratio`}>{worst.ratio.toFixed(1)}:1</strong> (aim for {MIN_RATIO}:1).</span>
      {fix && onFix && (
        <button type="button" onClick={() => onFix(fix)} data-testid={`${testid}-autofix`} className="inline-flex items-center gap-1.5 font-semibold text-amber-900 hover:underline whitespace-nowrap">
          <span className="w-3 h-3 rounded-sm border border-amber-300" style={{ background: fix }} /> Auto-fix
        </button>
      )}
    </div>
  );
};

export default function ColorField({ label, hint, value, fallback, placeholder, onChange, testid, against }) {
  const effective = value || fallback;
  return (
    <div>
      <label className="block text-sm font-medium text-[#16243b] mb-1.5">{label} {hint && <span className="text-[#8a97a8] font-normal">({hint})</span>}</label>
      <div className="flex items-center gap-3">
        <input type="color" value={effective} onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-picker`} className="w-12 h-10 rounded cursor-pointer border border-gray-200" />
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={`${testid}-input`} className="flex-1 rounded-xl border border-gray-200 px-4 py-2.5 outline-none focus:border-[#2ec9c9]" />
        {value ? <button type="button" onClick={() => onChange("")} data-testid={`${testid}-clear`} className="text-xs text-[#8a97a8] hover:text-red-500 whitespace-nowrap">Clear</button> : null}
      </div>
      {against && value && <ReadabilityWarning color={effective} against={against} onFix={onChange} testid={testid} />}
    </div>
  );
}
